// Update JoinTeam.jsx with file upload functionality (similar to Careers.jsx)
// ...existing imports and code, add file upload to the application form...
import React, { useState, useEffect } from 'react'
import { Users, Briefcase, Camera, Film, Send, Upload, X } from 'lucide-react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'

const JoinTeam = () => {
  const [selectedType, setSelectedType] = useState('all')
  const [opportunities, setOpportunities] = useState([])
  const [uploadedFile, setUploadedFile] = useState(null)
  const { register, handleSubmit, formState: { errors }, reset } = useForm()

  // ...existing code for types, sampleOpportunities...

  const handleFileUpload = (e) => {
    const file = e.target.files[0]
    if (file) {
      const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'image/jpeg', 'image/png']
      if (!allowedTypes.includes(file.type)) {
        toast.error('Please upload PDF, Word document, or image (JPG/PNG)')
        return
      }

      if (file.size > 5 * 1024 * 1024) {
        toast.error('File size must be less than 5MB')
        return
      }

      const reader = new FileReader()
      reader.onload = (event) => {
        setUploadedFile({
          name: file.name,
          size: file.size,
          type: file.type,
          data: event.target.result
        })
        toast.success('Portfolio uploaded successfully!')
      }
      reader.readAsDataURL(file)
    }
  }

  const removeFile = () => {
    setUploadedFile(null)
    toast.success('File removed')
  }

  const onSubmit = async (data) => {
    if (!uploadedFile) {
      toast.error('Please upload your resume/portfolio')
      return
    }

    const applications = JSON.parse(localStorage.getItem('shikdar_films_applications') || '[]')
    applications.push({
      ...data,
      portfolio: uploadedFile,
      timestamp: new Date().toISOString(),
      id: Date.now(),
      status: 'pending'
    })
    localStorage.setItem('shikdar_films_applications', JSON.stringify(applications))

    // Send notification
    const notifications = JSON.parse(localStorage.getItem('shikdar_films_notifications') || '[]')
    notifications.push({
      id: Date.now(),
      type: 'casting_application',
      title: 'New Casting/Crew Application',
      message: `${data.name} applied for ${data.position}`,
      timestamp: new Date().toISOString(),
      read: false
    })
    localStorage.setItem('shikdar_films_notifications', JSON.stringify(notifications))
    
    toast.success('Application submitted successfully! We will contact you soon.')
    reset()
    setUploadedFile(null)
  }

  // ...rest of the component with file upload UI similar to Careers.jsx
  // Add the file upload section in the form before the cover letter field

  return (
    <div className="min-h-screen bg-gray-50 py-16">
      {/* ...existing header and opportunities list... */}
      
      {/* Application Form with File Upload */}
      <div className="bg-white rounded-xl shadow-md p-8 max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <Briefcase className="w-8 h-8 text-bengal-green" />
          <h2 className="section-title text-2xl text-gray-900">Submit Your Application</h2>
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          {/* ...existing form fields... */}
          
          {/* File Upload Section */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Resume/Portfolio * (PDF, Word, or Images, max 5MB)</label>
            {!uploadedFile ? (
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-bengal-green transition-colors">
                <Upload className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                <label className="cursor-pointer">
                  <span className="text-bengal-green hover:text-bengal-orange font-medium">Click to upload</span>
                  <span className="text-gray-600"> or drag and drop</span>
                  <input
                    type="file"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    onChange={handleFileUpload}
                    className="hidden"
                  />
                </label>
                <p className="text-xs text-gray-500 mt-2">PDF, Word, or Images (max 5MB)</p>
              </div>
            ) : (
              <div className="border-2 border-bengal-green rounded-lg p-4 bg-green-50">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-bengal-green rounded-lg flex items-center justify-center">
                      <Upload className="w-5 h-5 text-white" />
                    </div>
                    <div>
                      <p className="font-medium text-gray-900">{uploadedFile.name}</p>
                      <p className="text-sm text-gray-600">{(uploadedFile.size / 1024).toFixed(2)} KB</p>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={removeFile}
                    className="w-8 h-8 bg-red-100 hover:bg-red-200 rounded-full flex items-center justify-center transition-colors"
                  >
                    <X className="w-4 h-4 text-red-600" />
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* ...rest of form fields and submit button... */}
        </form>
      </div>
    </div>
  )
}

export default JoinTeam